import { defineMiddleware } from '../middleware'
import { useAuthStore } from '@/features/auth'

/**
 * Guest middleware - only allows unauthenticated users
 * Redirects logged-in users to home page
 */
defineMiddleware('guest', () => {
  const authStore = useAuthStore()

  if (authStore.isAuthenticated) {
    return { name: 'home' }
  }

  return true
})
